export { default as Contratados } from "./Contratados"
export { default as ContratadosEditForm } from "./ContratadosEditForm"
export { default as ContratadosCreateForm } from "./ContratadosCreateForm"
export { default as TableContratados } from "./TableContratados"
export { default as TableNavContratados } from "./TableNavContratados"
export { default as ContratadosTrash } from "./ContratadosTrash"
export { default as TableContratadosTrash } from "./TableContratadosTrash"



// WEBPACK FOOTER //
// ./src/views/contratados/index.js